import React, { useRef } from 'react';
// @ts-ignore
import { useTabIndex } from 'react-tabindex';
import styled from 'styled-components';

// import { SelectedIcon } from '../../Common/Selector';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  showIcon?: string | boolean;
  value?: number | string;
  cordlessHoneycomb?: boolean;
}

const StyledWrapper = styled.label<{
  showIcon?: boolean | string;
  value?: number | string;
}>`
  display: flex;
  max-width: 300px;
  max-height: 100%;
  flex-wrap: wrap;
  border-radius: 10px;
  padding: 10px 16px;
  border: 1.5px solid #dadee2;
  box-shadow: 0 0 0 1px #dadee2;
  position: relative;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    padding: 16px;
  }

  ${({ showIcon, value }) => {
    if (value === '') return 'border-color: #dadee2';
    return showIcon === false && 'border-color: #d14a16';
  }}
`;

const StyledCaption = styled.div`
  font: normal normal normal 14px/20px Lato;
  letter-spacing: 0.28px;
  color: #292B30;
  text-align: left;
  flex: 0 0 calc(calc(100% - 80px) / 2);
  align-self: center;
`;

const StyledInput = styled.input<{ showIcon?: boolean | string }>`
  height: auto !important;
  width: auto !important;
  padding: 0 !important;
  border: 0 !important;
  flex: 1 !important;
  margin-bottom: 0 !important;
  text-align: right;

  &:focus {
    outline: 0;
  }
`;

const StyledUnit = styled.div`
  border: none;
  color: #000000;
  font: normal normal 300 13px/20px Lato;
  flex: 0 0 calc(calc(100% - 80px) / 2);
  align-self: center;
  flex: unset;
`;

const StyledMeasurementNote = styled.div<{
  showIcon?: boolean | string;
  value?: number | string;
}>`
  font: normal normal 300 12px/15px Lato;
  text-align: start;
  line-height: 18px;
  margin-top: 0px;
  margin-bottom: 15px;
  align-self: center;
  ${({ showIcon, value }) => {
    if (value === '') return 'color: #9a9a9a';
    return showIcon ? 'color: #9a9a9a' : 'color: #d14a16';
  }}
  max-width: 300px !important;
  margin-left: auto !important;
  margin-right: auto !important;

  @media (min-width: 1441px) {
    max-width: 300px;
  }
`;

const widthArrow = (min: any, max: any) => {
  return "Min" + " " + min + "mm - Max" + " " + max + "mm" + "<span class='arr-left size-arrow'>&larr;</span>&nbsp;<span class='arr-right size-arrow'>&rarr;</span>"
}

const heightArrow = (min: any, max: any) => {
  return "Min" + " " + min + "mm - Max" + " " + max + "mm" + "<span class='arr-up size-arrow'>&darr;</span>&nbsp;<span class='arr-down size-arrow'>&uarr;</span>"
}

const MeasurementInput = (props: Props) => {
  const tabIndex: number = useTabIndex();
  const input = useRef<HTMLInputElement>(null);

  const { value, min, max, name, cordlessHoneycomb } = props;

  const isLowValue =
    typeof value === 'number' && value && typeof min === 'number' && value < min
      ? true
      : false;
  const isHighValue =
    typeof value === 'number' && value && typeof max === 'number' && value > max
      ? true
      : false;

  return (
    <>
      <StyledWrapper
        showIcon={props.showIcon}
        value={props.value}
        htmlFor={`${props.name}-input`}
      >
        {/* {props.showIcon && <SelectedIcon />} */}
        <StyledCaption>{props.name}</StyledCaption>
        <StyledInput
          tabIndex={tabIndex}
          ref={input}
          {...props}
          onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (input === null || input.current === null) return;
            if (event.charCode === 13) input.current.blur();
          }}
        />
        <StyledUnit>mm</StyledUnit>
      </StyledWrapper>
      <StyledMeasurementNote
        showIcon={props.showIcon}
        value={props.value}
        id={`${props.name}-description`}
      >
        {isHighValue === true ? (
          <strong>!</strong>
        ) : isLowValue === true ? (
          <strong>!</strong>
        ) : (
          ''
        )}

        {isHighValue === true && cordlessHoneycomb === true && name === 'Width'
          ? `Maximum ${name} of ${max}mm exceeded. Please consider Cordloop option`
          : isHighValue === true &&
            cordlessHoneycomb === true &&
            name === 'Height'
            ? `Maximum ${name} of ${max}mm exceeded. Please consider Corded or Cordloop options`
            : isHighValue === true
              ? ` Maximum ${name} exceeded, must be below ${max}mm`
              : isLowValue === true
                ? ` Minimum ${name} not met, must be above ${min}mm`
                : `Min ${min}mm - Max ${max}mm`
                  ? props.name === "Width"
                    ? <div id="demo" dangerouslySetInnerHTML={{ __html: widthArrow(min, max) }} />
                    : <div dangerouslySetInnerHTML={{ __html: heightArrow(min, max) }} />
                  : null}
      </StyledMeasurementNote>
    </>
  );
};

export default MeasurementInput;
